export function Mentions(user, MentionedUser, setShowMentions) {
  const { username } = user;
  return (
    <div
      onClick={() => {
        MentionedUser(username);
        setShowMentions(false);
      }}
      className="mention-user"
    >
      {username}
    </div>
  );
}
